import { createSlice } from '@reduxjs/toolkit'
import { fetchProjects } from '../../asyncs/ProjectAsyncs';

export const projectSlice = createSlice({
  name: 'project',
  initialState: {
    title: '',
    categories: [],
    data: []
  },
  reducers: {
    addTitle: (state, action) => {
      state.title = action.payload
    },
    addCategories: (state, action) => {
      state.categories = [...state.categories, ...action.payload]
    },
    resetState: (state) => {
      state.title = '';
      state.categories = [];
    },
    getAllProjects: (state, action) => {
      state.data = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchProjects.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.data = action.payload
        state.status = 'idle'
      })
  }
})

export const { addTitle, addCategories, resetState, getAllProjects } = projectSlice.actions

export default projectSlice.reducer